const PREVIEW_BLOCKS = 2;

let collapsibleTextAbort = null;

function setupCollapsible(element, signal) {
  const toggle = element.querySelector(".js-collapsible-text-toggle");
  const content = element.querySelector(".js-collapsible-text-content");

  if (!toggle || !content) {
    return;
  }

  const blocks = Array.from(content.children);

  if (blocks.length <= PREVIEW_BLOCKS) {
    element.setAttribute("data-collapsible", "false");
    element.setAttribute("data-state", "open");
    return;
  }

  element.setAttribute("data-collapsible", "true");

  toggle.addEventListener(
    "click",
    (event) => {
      event.preventDefault();

      const isClosed = element.getAttribute("data-state") === "closed";
      element.setAttribute("data-state", isClosed ? "open" : "closed");
    },
    signal ? { signal } : undefined
  );
}

export function initCollapsibleText(root = document) {
  const elements = root.querySelectorAll(".js-collapsible-text");

  if (elements.length === 0) {
    return;
  }

  if (root === document) {
    collapsibleTextAbort?.abort();
    collapsibleTextAbort = new AbortController();
  }

  const signal = root === document ? collapsibleTextAbort.signal : undefined;

  elements.forEach((element) => {
    setupCollapsible(element, signal);
  });
}

export const collapsibleText = () => initCollapsibleText();
